/**
 * Calculate due date based on task frequency/cadence
 * @param {string} cadence - 'daily', 'weekly', 'monthly', or 'yearly'
 * @returns {Date} The calculated due date
 */
export const calculateTaskDueDate = (cadence) => {
  const today = new Date();
  
  switch (cadence) {
    case 'daily':
      // For daily tasks, due date is same day
      return new Date(today);
    
    case 'weekly':
      // End of week (Saturday) - unless Saturday is a weekend off day
      // Calculate days until Saturday (day 6)
      const currentDay = today.getDay(); // 0 = Sunday, 6 = Saturday
      const daysUntilSaturday = currentDay === 6 ? 0 : (6 - currentDay);
      const saturdayDate = new Date(today);
      saturdayDate.setDate(saturdayDate.getDate() + daysUntilSaturday);
      return saturdayDate;
    
    case 'monthly':
      // Last day of the month
      const lastDayOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);
      return lastDayOfMonth;
    
    case 'yearly':
      // Fiscal year end (March 31)
      // If current date is before April, fiscal year ends on March 31 of current year
      // If current date is April or later, fiscal year ends on March 31 of next year
      const month = today.getMonth(); // 0 = January, 3 = April
      const fiscalYearEndDate = month < 3
        ? new Date(today.getFullYear(), 2, 31) // March 31 of current year
        : new Date(today.getFullYear() + 1, 2, 31); // March 31 of next year
      return fiscalYearEndDate;
    
    default:
      return new Date(today);
  }
};

/**
 * Format a date for display
 * @param {Date} date - The date to format
 * @returns {string} Formatted date string (e.g., "Dec 31, 2024")
 */
export const formatDateForDisplay = (date) => {
  if (!date) return '';
  const options = { year: 'numeric', month: 'short', day: 'numeric' };
  return new Date(date).toLocaleDateString('en-US', options);
};

/**
 * Format a date for datetime-local input
 * @param {Date} date - The date to format
 * @returns {string} Formatted date string for datetime-local (e.g., "2024-12-31T23:59")
 */
export const formatDateForInput = (date) => {
  if (!date) return '';
  const d = new Date(date);
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}T23:59`;
};
